<template>
        <div id='traindetail'>
            <NavTop title='培训详情' :islink='true' linkurl='/trainlist'/>
            <div class='content'>
               <div class="topcon" v-if="traininfo.bmstatus==1">
                   <div class="topcon-row1">恭喜您成功报名</div>
                   <div class="topcon-row2">您的专属学号:<span class="topcon-highlight">{{traininfo.passcode}}-{{traininfo.studentname}}</span></div>
               </div>
               <div class="titlecon">
                   <div class="titlecon-row1">{{traininfo.name}}</div>
                   <div class="titlecon-row2">报名时间:{{traininfo.startdate}}-{{traininfo.enddate}}</div>
               </div>
               <div class='mycontent' v-html="traininfo.content"></div>
               <div class="bottomcon">
                   <div class="bmbtn gobm" v-if="traininfo.bmstatus==0" @click="goBm">
                       <span>去参加报名</span> 
                   </div> 
                   <div class="bmbtn" v-else>
                       <span v-if="traininfo.bmstatus==1">已参加报名</span>
                       <span v-else-if="traininfo.bmstatus==2">报名未开始</span>
                       <span v-else-if="traininfo.bmstatus==3">报名已结束</span>
                  </div> 
               </div>
            </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
export default {
  data(){
      return{
         traininfo:{}
      }
  },  
  name: 'traindetail',
  created(){
     this.getTrainInfo()
  },
  methods:{
      getTrainInfo(){
         if(this.$route.params.trainid==undefined){
               this.$toast("页面参数有误，请稍后再试")
               return false
         } 
         this.$post("/school/getTrainInfo",{trainid:this.$route.params.trainid}).then((data)=>{
                  if(data.result.success){
                     this.traininfo=data.result.info
                  }else{
                  this.$toast(data.result.info)
                  }
            })   
      },
      goBm(){
         this.$go({name:'trainsure',params:{trainid:this.$route.params.trainid}}) 
      }
  },
  components:{
      NavTop
  }
}
</script>
<style scoped>
#traindetail{background-color:#F6F6F6;min-height: 100vh;width:100%;}
.content{font-size:0.5rem;overflow-x:hidden;word-break:break-all;text-align: left;padding: 0.35rem;padding-top: 0!important;}
.topcon{display: flex;background:linear-gradient(to bottom,#3d3b43,#2d2b31,#1d1d21);border-radius: 0.25rem;flex-flow: column nowrap;justify-content: center;align-items: center;height:3rem;}
.topcon-row1{font-size:0.6rem;color:#fff;}
.topcon-row2{font-size:0.55rem;color:#fff;margin-top:0.15rem;}
.topcon-highlight{color:#fbcc98}
.titlecon{display: flex;flex-flow: column nowrap;justify-content: center;align-items: center;height:1.5rem;}
.titlecon-row1{color:#000;font-size:0.45rem;font-weight: 600;}
.titlecon-row2{color:#666666;font-size:0.35rem;margin-top:0.1rem;}
.bottomcon{margin-top:0.2rem;width:100%;display: flex;flex-flow: row nowrap;justify-content: center;align-items: center;}
.bmbtn{width:100%;background-color: #999999;color:#fff;font-size:0.35rem;border-radius: 0.2rem;text-align: center;padding: 0.2rem;height:1.15rem;display: flex;flex-flow: row nowrap;align-items: center;justify-content: center;}
.gobm{background-color: #ee0a24;}
</style>


